export default __webpack_public_path__ + "static/BNT-237586931c4c28ed28092afb9faac4a3.png";